import { useContext } from "react";
import { Example } from "./Example";
import { AppStateContext } from "../../state/AppProvider";

interface Props {
    onExampleClicked: (value: string) => void;
}

export const ExampleList = ({ onExampleClicked }: Props) => {
    const appStateContext = useContext(AppStateContext);

    return (
        <ul className="flex flex-wrap gap-4 justify-center">
            {appStateContext?.state.assistant?.examples.map((x, i) => (
                <li key={i} className="lg:last:list-item last:hidden">
                    <Example text={x} value={x} onClick={onExampleClicked} />
                </li>
            ))}
        </ul>
    );
};
